/**
 * Extracted from `components/product-home/product-home-parts.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import {
  openableIdentities,
  openAs,
  OPEN_AS_LABEL,
  type WorkspaceRole,
} from "@/lib/login-session"
import {
  collectWhatsNewUpdates,
  whatsNewUpdateId,
  type ProductHomeCard,
} from "@/lib/product-home"
import { isSchoolScopedProduct } from "@/lib/scope-switcher"
import { cn } from "@/lib/utils"

export function firstName(full: string): string {
  return full.split(/\s+/)[0] ?? full
}

export function greetingForHour(hour: number): string {
  if (hour < 5) return "Still up"
  if (hour < 12) return "Good morning"
  if (hour < 17) return "Good afternoon"
  return "Good evening"
}

export function openableDoors(card: ProductHomeCard): WorkspaceRole[] {
  if (card.href || !isSchoolScopedProduct(card.product)) return []
  return openableIdentities()
}

export function ownedGridClassName(count: number): string {
  return cn(
    "grid list-none gap-4 p-0",
    count === 1 && "max-w-md",
    count === 2 && "max-w-3xl sm:grid-cols-2",
    count >= 3 && "sm:grid-cols-2",
    count >= 3 && count !== 4 && "xl:grid-cols-3",
  )
}
